import { render } from "./architectureFirstScreen.vue?vue&type=template&id=30b3b010"
import script from "./architectureFirstScreen.vue?vue&type=script&lang=js"
export * from "./architectureFirstScreen.vue?vue&type=script&lang=js"

import "./architectureFirstScreen.vue?vue&type=style&index=0&id=30b3b010&lang=scss"

import exportComponent from "F:\\freelance\\web development\\project twelve\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__